import React from 'react';
import ReactDOM from 'react-dom/client';

import { SiteApp } from './studio/SiteApp';
import { findMissingEnv } from './studio/config/requiredEnv';
import { ThemeProvider, resolveInitialTheme, applyTheme } from './studio/design/theme';
import './studio/design/fonts.css';
import './studio/design/soulstack.css';
import './studio/studio.css';

// Ensure a theme attribute is present before first paint even if the inline
// index.html bootstrap did not run (e.g. embedded mounts).
if (!document.documentElement.getAttribute('data-theme')) {
  applyTheme(resolveInitialTheme());
}

// Validate required environment variables before mounting. Missing vars would
// cause cryptic runtime failures deep in auth or API calls; surface them early.
const missing = findMissingEnv(import.meta.env as unknown as Record<string, unknown>);
if (missing.length > 0) {
  document.body.style.cssText =
    'margin:0;display:flex;align-items:center;justify-content:center;height:100vh;' +
    'font-family:system-ui,sans-serif;background:var(--ss-bg);color:var(--ss-text);text-align:center;';
  document.body.innerHTML = `
    <div style="max-width:480px;padding:0 24px">
      <h1 style="font-size:22px;font-weight:600;margin-bottom:12px">Configuration Error</h1>
      <p style="font-size:14px;color:var(--ss-text-2);margin-bottom:16px;line-height:1.6">
        The following required environment variables are missing:
      </p>
      <ul style="text-align:left;font-family:monospace;font-size:13px;line-height:2;color:var(--ss-danger);margin-bottom:16px">
        ${missing.map((v) => `<li>${v}</li>`).join('')}
      </ul>
      <p style="font-size:13px;color:var(--ss-text-2)">
        Please check your deployment configuration or <code>.env</code> file.
      </p>
    </div>
  `;
  throw new Error(`Missing required env vars: ${missing.join(', ')}`);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <SiteApp />
    </ThemeProvider>
  </React.StrictMode>,
);
